import config from '@/config';
import requestAPI, { getLocaleString } from '@/logic/requestBeApi';

const newsletter = {
  patchUrl: '/api/v1/users/{ID}/newsletter',

  postSubscription(email: string): Promise<Response> {
    // after last BE changes this method may not be used
    // think what to do with it during a next refactor
    const headers = {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      'X-LOCALE': getLocaleString(),
    };

    if (config.isOnDevEnv) delete headers['X-LOCALE'];

    return fetch(config.BE_URL + '/api/v1/newsletters', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        email: email,
      }),
    });
  },

  async updateSubscription(userId: string, subscribe: boolean): Promise<Response> {
    const url = this.patchUrl.replace('{ID}', userId);
    const payload = {
      newsletter: subscribe,
    };

    const response = await requestAPI({
      url,
      method: 'PATCH',
      contentType: 'application/merge-patch+json',
      payload,
    });

    return response;
  },
};

export default newsletter;
